import React from 'react'
import classNames from 'classnames'
import { matchPath } from 'react-router-dom'
import Tooltip from 'antd/lib/tooltip'
import styles from '../index.scss'

interface IProps {
    title: string
    collapsed: boolean
    icon: any
    path?: string
    onClick?: () => void
}

function MenuTooltip(props: IProps) {
    const { title, collapsed, icon, path = '', onClick = () => undefined } = props
    const isMatch = React.useCallback(
        path =>
            matchPath(location.pathname, {
                path,
                exact: false,
                strict: false
            }),
        [location]
    )
    return (
        <Tooltip
            overlayClassName={classNames(styles['menu-tooltip'], {
                [styles['menu-tooltip__force_hidden']]: !collapsed
            })}
            arrow={false}
            placement="right"
            title={title}
        >
            <div
                className={classNames(styles['menu-item'], {
                    [styles.active]: isMatch(path),
                    [styles.collapsed]: !collapsed,
                    [styles['menu-guide-item']]: !path,
                    [styles['menu-item__bottom']]: !path
                })}
                onClick={onClick}
            >
                {icon}
                {!collapsed && <span>{title}</span>}
            </div>
        </Tooltip>
    )
}

export default MenuTooltip
